import React from 'react';
import styles from './PopularArticleCard.module.scss';
import Image from 'next/image';
import Container from 'components/container';
import { Heading, Body } from 'components/text';
import { TravelJournalArticlesType } from 'types/types';
import Arrow from 'assets/svg/arrow-long-right.svg';
import ArticleLink from 'blocks/travel-journal-articles/home/article-link';
import CategoryLink from 'blocks/travel-journal-articles/home/category-link/CategoryLink';

export type ArticleCardTypeProps = {
  article: TravelJournalArticlesType;
};

const PopularArticleCard: React.FC<ArticleCardTypeProps> = ({ article }) => {
  const { title, introduction, header_image, categories } = article;

  return (
    <Container as="article" className={styles.container}>
      <Container className={styles.imageContainer}>
        <ArticleLink key={article.id} article={article}>
          <Image
            priority
            src={header_image}
            layout="fill"
            objectPosition="center"
            objectFit="cover"
            alt={title}
            sizes="(max-width: 768px) 200vw, (max-width: 1024px) 100vw, 40vw"
          />
        </ArticleLink>
      </Container>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderTop}>
          <div className={styles.categories}>
            {categories?.map((category, index) => (
              <CategoryLink key={index} category={category}>
                <Body key={index} color="gold-dark" weight="demiBold">
                  {category.name}
                </Body>
              </CategoryLink>
            ))}
          </div>
          <ArticleLink key={article.id} article={article}>
            <Heading as="h4" color="grey-dark" weight="medium">
              {title}
            </Heading>
          </ArticleLink>
          <div className={styles.introduction}>
            <Body color="grey-dark" fontSize={18}>
              {introduction}
            </Body>
          </div>
        </div>
        <ArticleLink key={article.id} article={article}>
          <div className={styles.arrow}>
            <Arrow />
            <Body color="gold-dark" weight="demiBold">
              Read more
            </Body>
          </div>
        </ArticleLink>
      </div>
    </Container>
  );
};

export default PopularArticleCard;
